// 🌍 Plugin d'exécution sécurisée avec confirmation + loading
export default {
  install(Vue) {
    const ActionGuard = {
      /**
       * Exécute une action avec confirmation et affichage de chargement
       * @param {Object} options
       * @param {String} options.message - Message à afficher dans la boîte de dialogue
       * @param {Function} options.action - Fonction async à exécuter si confirmé
       */
      async confirmAndExecute({ message = "Confirmer l’action ?", action }) {
        try {
          // 🧠 Étape 1 : Demander confirmation
          const confirmed = await new Promise((resolve) => {
            const box = document.createElement("div");
            box.className = "confirm-overlay";
            box.innerHTML = `
              <div class="confirm-dialog">
                <p>${message}</p>
                <div class="confirm-buttons">
                  <button id="yes-btn">Oui</button>
                  <button id="no-btn">Non</button>
                </div>
              </div>
            `;
            document.body.appendChild(box);

            box.querySelector("#yes-btn").onclick = () => {
              box.remove();
              resolve(true);
            };
            box.querySelector("#no-btn").onclick = () => {
              box.remove();
              resolve(false);
            };
          });

          if (!confirmed) return false;

          // 🌀 Étape 2 : Afficher le chargement
          const loader = document.createElement("div");
          loader.className = "loading-overlay";
          loader.innerHTML = `<div class="spinner"></div><p>Chargement...</p>`;
          document.body.appendChild(loader);

          // 🧩 Étape 3 : Exécuter l’action
          await action();

          // ✅ Étape 4 : Supprimer le loader
          loader.remove();

          return true;
        } catch (error) {
          console.error("Erreur dans ActionGuard:", error);
          alert("❌ Une erreur s’est produite !");
          const loader = document.querySelector(".loading-overlay");
          if (loader) loader.remove();
          return false;
        }
      },
    };

    // Rendre accessible via this.$guard
    Vue.prototype.$guard = ActionGuard;
  },
};
